module.exports = __webpack_public_path__ + "static/media/loopBack.a3801832.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/loopBack.png
// module id = 140
// module chunks = 0